import { configureStore } from '@reduxjs/toolkit';
import templateCopyItemReducer from './TemplateCopyItemSlice';

const templateCopyItemStore = configureStore({
  reducer: {
    templateCopyItem: templateCopyItemReducer
  }
});

export default templateCopyItemStore;